import React, { Component } from "react";
import { Card, FlatButton, Subheader, Divider, CardTitle } from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FilterIndex from "../FilterIndex";

export default class ClientNagIndex extends Component {
  constructor(props) {
    super(props);

    this.renderTable = this.renderTable.bind(this);
    this.viewButton = this.viewButton.bind(this);
  }

  viewButton(cell, row) {
    let url = `/job/communicationsManager/massEmailer/processClientNag/${cell}`;
    return (
      <FlatButton
        label="View"
        backgroundColor="#E0E0E0"
        hoverColor="#BDBDBD"
        onClick={this.props.performRoute.bind(this, url)}
      />
    );
  }

  renderTable() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      let tableDate = this.props.workOrders.map((clientNag) => {
        return {
          uid__c: clientNag.client.uid__c,
          name: clientNag.client.name,
          email: clientNag.client.primary_email__c,
          template: clientNag.template.name,
          status: clientNag.status,
          _id: clientNag._id,
        };
      });
      return (
        <div>
          <BootstrapTable data={tableDate} pagination>
            <TableHeaderColumn
              dataField="uid__c"
              filter={filter}
              dataSort
              isKey
              width="125"
            >
              ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="name" dataSort filter={filter}>
              Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="email"
              dataSort
              filter={filter}
              width="300"
            >
              Email
            </TableHeaderColumn>
            <TableHeaderColumn dataField="template" dataSort filter={filter}>
              Template
            </TableHeaderColumn>
            <TableHeaderColumn dataField="status" dataSort filter={filter}>
              Status
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="_id"
              dataFormat={this.viewButton}
              width="100"
            ></TableHeaderColumn>
          </BootstrapTable>
        </div>
      );
    }
  }

  render() {
    return (
      <Card
        className="container"
        style={{ marginTop: "2em", padding: "2em 7em 0em 7em" }}
      >
        <CardTitle title="Emails" />
        <Divider style={{ margin: "1em 1em" }} />
        <FilterIndex
          url="email/clientNags"
          filterKey="status"
          {...this.props}
        />
        <br />
        {this.renderTable()}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/ClientNagIndex.js